import { cva, type VariantProps } from 'class-variance-authority';

export const weightVariants = cva('', {
  variants: {
    weight: {
      black: 'tw-font-black',
      bold: 'tw-font-bold',
      extrabold: 'tw-font-extrabold',
      extralight: 'tw-font-extralight',
      light: 'tw-font-light',
      medium: 'tw-font-medium',
      normal: 'tw-font-normal',
      semibold: 'tw-font-semibold',
      thin: 'tw-font-thin',
    },
  },
});

export const spacingVariants = cva('', {
  variants: {
    spacing: {
      lg: 'tw-tracking-light',
      sm: 'tw-tracking-lighter',
    },
  },
});

export const textVariants = cva(
  'tw-m-0 tw-p-0 text',
  {
    defaultVariants: {
      variant: 'body',
    },
    variants: {
      variant: {
        body: 'body',
        heading1: 'heading1',
        heading2: 'heading2',
        heading3: 'heading3',
        heading4: 'heading4',
        heading5: 'heading5',
        label: 'labels',
      },
      // eslint-disable-next-line sort-keys
      size: {
        lg: 'lg',
        sm: 'sm',
        xl: 'xl',
        xs: 'xs',
      },
    },
  },
);

type TextVariantProps = VariantProps<typeof textVariants>;

export function defaultTagForVariant(variant: TextVariantProps['variant']) {
  switch (variant) {
  case 'body':
    return 'p';
  case 'heading1':
    return 'h1';
  case 'heading2':
    return 'h2';
  case 'heading3':
    return 'h3';
  case 'heading4':
    return 'h4';
  case 'heading5':
    return 'h5';
  case 'label':
    return 'label';
  default:
    return 'p';
  }
}

export type FontWeight =
  'thin'
  | 'extralight'
  | 'light'
  | 'normal'
  | 'medium'
  | 'semibold'
  | 'bold'
  | 'extrabold'
  | 'black';
